import React, { useEffect, useState } from 'react';
import './programassociales.css';

const DGSP = () => {

  const [expandida, setExpandida] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const PDF_URL =
    'https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/pdf/Poligonos.pdf';

  useEffect(() => {
    window.scrollTo(0, 0);

    const mobile = window.innerWidth <= 768;
    setIsMobile(mobile);

    if (mobile) {
      window.location.replace(PDF_URL);
    }
  }, []);

  const togglePdf = () => {
    setExpandida(!expandida);
  };

  return (
    <div
      className='container-full-width'
      style={{
        backgroundImage: `url('https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/DGSP2026.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh'
      }}
    >
      <div className='row'>
        <div className='col-12'>

          <h3
            className='title'
            style={{
              color: 'white',
              fontWeight: 'bold',
              textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
              textAlign: 'center'
            }}
          >
            Dirección General <br />de Servidores del Pueblo
          </h3>

          <div className="hero">

            <h4>POLÍGONOS</h4>

            {!isMobile && (
              <div className="contenedor">
                <iframe
                  src={`${PDF_URL}#zoom=page-width`}
                  title="Visor PDF"
                  className={expandida ? "pdf expandida" : "pdf"}
                  onClick={togglePdf}
                />
              </div>
            )}

          </div>

          <hr className='hr-gob' />

        </div>
      </div>
    </div>
  );
};

export default DGSP;